"use client";

import { useTheme } from "next-themes";
import { Toaster as Sonner, ToasterProps } from "sonner";
import { CheckCircle2, AlertCircle, Info } from "lucide-react";

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme();

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className="toaster group"
      icons={{
        success: <CheckCircle2 className="h-4 w-4 text-success-500" />,
        error: <AlertCircle className="h-4 w-4 text-danger-500" />,
        warning: <AlertCircle className="h-4 w-4 text-warning-500" />,
        info: <Info className="h-4 w-4 text-info-500" />,
      }}
      toastOptions={{
        unstyled: true,
        classNames: {
          success:
            "bg-success-50 border border-success-200 rounded-2xl shadow-sm",
          error: "bg-danger-50 border border-danger-200 rounded-2xl shadow-sm",
          warning:
            "bg-warning-50 border border-warning-200 rounded-2xl shadow-sm",
          info: "bg-info-50 border border-info-200 rounded-2xl shadow-sm",
          toast: "group toast flex gap-1 items-start px-4 py-3",
          content: "flex flex-col",
          title: "text-darkgray-900 text-base font-medium -mt-[3px]",
          description: "!text-darkgray-600 text-sm",
        },
      }}
      {...props}
    />
  );
};

export { Toaster };
